module.exports = __webpack_public_path__ + "static/media/16.dfd69606.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/accessoires/16.png
// module id = 1121
// module chunks = 0